import { Result } from '@headless-workspace/core-domain';
import { CustomerValue, UserSephoraCard, UserSephoraCardUnlimited, UserValue } from '../customer/CustomerValue';

export enum UserConnectionStatus {
    Guest = 'guest',
    Registered = 'registered',
}

export type ConnectedUserInfo = Readonly<
    {
        status: UserConnectionStatus.Registered;
        email: string;
        customerEncryptedEmail: string;
    } & UserValue
>;

export type GuestUserInfo = Readonly<{
    status: UserConnectionStatus.Guest;
}>;

export type UserInfo = ConnectedUserInfo | GuestUserInfo;

export const isConnectedUserInfo = (userInfo: UserInfo | undefined): userInfo is ConnectedUserInfo => {
    return userInfo?.status === UserConnectionStatus.Registered;
};

export const isGuestUserInfo = (userInfo: UserInfo | undefined): userInfo is GuestUserInfo => {
    return userInfo?.status === UserConnectionStatus.Guest;
};

export const getConnectedUserInfo = (userInfoResult: Result<UserInfo>): ConnectedUserInfo | undefined => {
    return userInfoResult.type === 'success' && isConnectedUserInfo(userInfoResult.data)
        ? userInfoResult.data
        : undefined;
};

export const mapConnectedUserInfo = (
    customer: CustomerValue,
    email: string,
    customerEncryptedEmail: string,
): ConnectedUserInfo => {
    return {
        status: UserConnectionStatus.Registered,
        email,
        customerEncryptedEmail,
        ...customer,
    };
};

export const isUserGold = (userInfo: ConnectedUserInfo): boolean => {
    return userInfo.loyalty?.sephoraCard === UserSephoraCard.Gold;
};

export const isUserUnlimited = (userInfo: ConnectedUserInfo): boolean => {
    return (
        userInfo.loyalty?.sephoraCard === UserSephoraCardUnlimited.Star ||
        userInfo.loyalty?.sephoraCard === UserSephoraCardUnlimited.Standard
    );
};

export const isUserGoldOrUnlimited = (userInfo: ConnectedUserInfo): boolean => {
    return isUserGold(userInfo) || isUserUnlimited(userInfo);
};

export const hasFidelityProgram = (userInfo: ConnectedUserInfo): boolean => {
    return !!userInfo.loyalty;
};

export const generateDefaultNickname = (userInfo: ConnectedUserInfo): string => {
    const firstPart = userInfo.firstName.slice(0, 2).toUpperCase();
    const lastPart = userInfo.lastName.slice(0, 2).toUpperCase();

    return firstPart + lastPart;
};
